import api from '../services/ApiService';

export const SHOW_ROOM = 'SHOW_ROOM';
export const HIDE_ROOM = 'HIDE_ROOM';
export const SEND_MESSAGE = 'SEND_MESSAGE';
export const GET_USERS = 'GET_USERS';
export const SET_ACTIVE_ROOM = 'SET_ACTIVE_ROOM';
export const SET_ONLINE_STATUS = 'SET_ONLINE_STATUS';

export function getUsers() {
  return {
    type: GET_USERS,
    payload: api.get('/chat/users'),
  };
}

export function sendMessage(userId, message) {
  return {
    type: SEND_MESSAGE,
    payload: api.post(`/chat/user/${userId}`, { message }),
  };
}

export function showRoom(room) {
  return {
    type: SHOW_ROOM,
    room,
  };
}

export function hideRoom(room) {
  return {
    type: HIDE_ROOM,
    room,
  };
}

export function setActive(roomId) {
  return {
    type: SET_ACTIVE_ROOM,
    activeRoom: roomId,
  };
}

export function setOnlineStatus(userId, status) {
  return {
    type: SET_ONLINE_STATUS,
    userId,
    status,
  };
}
